<template>
<svg data-svg-lvl-3="flyleafend-block-flyleafend" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 514 430"><defs></defs><g id="Нахзац"><path class="lfe-c-3" d="M256.74,282H78.88a12,12,0,0,1-12-12V159.84a12,12,0,0,1,12-12H256.74Z"/><path class="lfe-c-3" d="M280.58,154.91h166a0,0,0,0,1,0,0V286.67a0,0,0,0,1,0,0h-166a12,12,0,0,1-12-12V166.91A12,12,0,0,1,280.58,154.91Z" transform="translate(715.18 441.59) rotate(-180)"/></g></svg></template>


<script>
/** Этот компонент генерируется автоматически, руками ничего менять нельзя!!! */
  
export default {props: { params: { type: Object, required: true, }, }, data() { return {} },}
</script>

<style scoped>.lfe-c-1{opacity:0.3;}.lfe-c-2{fill:#64ff00;}.lfe-c-3{fill:#f4e8ce;}</style>

